import palette from '../palette';

export default {
  root: {
    color: palette.icon,
    padding: 8,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.03)',
    },
    '&$disabled': {
      color: palette.icon,
    },
  },
};
